var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGreen = function SvgGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_green)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter_ddii_green)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4444 94.8889C74.9904 94.8889 94.8889 74.9904 94.8889 50.4444C94.8889 25.8985 74.9904 6 50.4444 6C25.8985 6 6 25.8985 6 50.4444C6 74.9904 25.8985 94.8889 50.4444 94.8889Z",
    fill: "#E3C19A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.5509 50.4443C90.5509 28.2908 72.592 10.3319 50.4385 10.3319C28.2851 10.3319 10.3262 28.2908 10.3262 50.4443C10.3262 72.5977 28.2851 90.5566 50.4385 90.5566C72.592 90.5566 90.5509 72.5977 90.5509 50.4443Z",
    fill: "#FBF4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.444 88.0369C71.2059 88.0369 88.0369 71.2059 88.0369 50.444C88.0369 29.682 71.2059 12.8511 50.444 12.8511C29.682 12.8511 12.8511 29.682 12.8511 50.444C12.8511 71.2059 29.682 88.0369 50.444 88.0369Z",
    fill: "url(#paint_linear_green)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6875 51.7674C28.3666 55.1207 38.0458 56.317 47.29 51.7674C56.5341 47.2178 69.7297 44.2271 77.4332 45.224C80.0506 45.6138 82.6414 46.1646 85.191 46.8734C83.9972 38.1886 79.5863 30.2686 72.8313 24.681C66.0763 19.0935 57.4696 16.2458 48.715 16.7017C39.9604 17.1575 31.696 20.8837 25.5579 27.1426C19.4197 33.4014 15.8551 41.7368 15.5698 50.4986C16.458 50.9517 17.4912 51.3143 18.6875 51.7674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8755 60.3771C22.6214 74.0076 36.2338 85.1731 50.3357 85.1731C60.2505 85.0644 71.1441 79.6085 76.2918 72.7751C78.1044 65.1623 62.0631 74.3158 50.3357 74.1708C35.7626 74.4789 20.2106 53.6524 16.8755 60.3771Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter_ddii_green",
    x: 0,
    y: 0.5,
    width: 100.889,
    height: 99.8889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow",
    result: "effect4_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_green",
    x1: 49.8458,
    y1: 15.2981,
    x2: 51.024,
    y2: 83.3604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A753"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_green"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/green.1a882f3b.svg";
export { ForwardRef as ReactComponent };